import { all, takeLatest } from 'redux-saga/effects';
import * as shareActions from '../actions';
import fetchTags from './worker.fetchTags';

function* shareSaga() {
  yield all([takeLatest(shareActions.fetchTagsData.type, fetchTags)]);
}

export default shareSaga;
